import { IPaginationRequest } from "interfaces/pagination";
import axios from "axios";

export type TCreatePromotionData = {
  name: string;
  description: string;
  image: string;
  price: number;
  url: string;
};

const PromotionService = axios.create({
  baseURL: `${process.env.REACT_APP_API}/promotion`,
});

const PromotionServices = {
  getDetail: (token: string, line_oa_code: string, id: string) =>
    PromotionService.get(`/${line_oa_code}/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
  getAll: (
    token: string,
    line_oa_code: string,
    pagination: IPaginationRequest
  ) =>
    PromotionService.get(
      `/${line_oa_code}/list?perPage=${pagination.per_page}&page=${pagination.page}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    ),
  create: (token: string, line_oa_code: string, data: TCreatePromotionData) =>
    PromotionService.post(`/${line_oa_code}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
  edit: (
    token: string,
    line_oa_code: string,
    id: string | number,
    data: TCreatePromotionData
  ) =>
    PromotionService.put(`/${line_oa_code}/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
  delete: (token: string, line_oa_code: string, id: string | number) =>
    PromotionService.delete(`/${line_oa_code}/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
};

export default PromotionServices;
